import { render, staticRenderFns } from "./OrderAuthVerify.vue?vue&type=template&id=e08155d6&scoped=true&"
import script from "./OrderAuthVerify.vue?vue&type=script&lang=js&"
export * from "./OrderAuthVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08155d6",
  null
  
)

export default component.exports